/* eslint-disable react/forbid-prop-types */
import React, { useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { ScenarioContext, IScenarioContext } from '@bingads-webui-react/instrumentation-context';

export const withScenarioContext = <P extends object>(WrappedComponent: React.ComponentType<P & { scenario: IScenarioContext }>): React.ComponentType<P> => {
  const HoC: React.FC<P> = (props) => {
    const context = useContext(ScenarioContext);

    return (
      <WrappedComponent
        {...props}
        scenario={context}
      />
    );
  };

  HoC.displayName = `withScenarioContext(${getDisplayName(WrappedComponent)})`;

  return hoistNonReactStatics(HoC, WrappedComponent);
};
